import { Client } from '@interfaces/FW/Client';
import { t } from 'i18next';

export const operationalInformation = (client: Client) => {
	return [
		{
			key: 1,
			title: t('aboutCompany.generalOverdraft'),
			value: client.generalOverdraft,
		},

		{
			key: 2,
			title: t('aboutCompany.overdraftStatus'),
			value:
				client.overdraftStatus === 0
					? t('aboutCompany.active')
					: client.overdraftStatus === 1
						? t('aboutCompany.inactive')
						: t('aboutCompany.notInstalled'),
		},
		{
			key: 3,
			title: t('aboutCompany.topstitching'),
			value: client.topstitching,
		},
		{
			key: 4,
			title: t('aboutCompany.numberOfDaysOfDebt'),
			value: client.numberOfDaysOfDebt,
		},
		{
			key: 5,
			title: t('aboutCompany.numberOfOverdueDaysOfDebtc'),
			value: client.numberOfOverdueDaysOfDebtc,
		},
		// {
		// 	key: 6,
		// 	title: t('aboutCompany.debtAmount'),
		// 	value: client.debtAmount
		// },
		{
			key: 7,
			title: t('aboutCompany.amountOfOverdueDebt'),
			value: client.amountOfOverdueDebt,
		},
		{
			key: 8,
			title: t('aboutCompany.numberOfDaysUntilBlocking'),
			value: client.numberOfDaysUntilBlocking,
		},
		// {
		// 	key: 9,
		// 	title: t('aboutCompany.cooperationSchemeName'),
		// 	value: client.cooperationSchemeName
		// }
	];
};
